import React from "react";
import { Img } from "../Img";


function BrandList() {
  return (
   <div className="w-full bg-gray-100 py-10 my-0 md:px-5 md:py-3">
    <div className="container mx-auto">
  

    <div className="flex justify-between md:justify-center gap-5 md:flex-wrap">
        <h1 className="text-4xl font-bold self-center md:text-2xl md:min-w-full md:text-center" >Top Brands</h1>
        <Img src="/images/brands/brand-1.svg "  className="h-[120px] my-5 md:my-2 md:h-[40px]" alt="brand-1"/>
        <Img src="/images/brands/brand-2.svg "  className="h-[120px] my-5 md:my-2 md:h-[40px]" alt="brand-1"/>
        <Img src="/images/brands/brand-3.svg "  className="h-[120px] my-5 md:my-2 md:h-[40px]" alt="brand-1"/>
        <Img src="/images/brands/brand-4.svg "  className="h-[120px] my-5 md:my-2 md:h-[40px]" alt="brand-1"/>
        <Img src="/images/brands/brand-5.svg "  className="h-[120px] my-5 md:my-2 md:h-[40px]" alt="brand-1"/>
        <Img src="/images/brands/brand-6.svg "  className="h-[120px] my-5 md:my-2 md:h-[40px]" alt="brand-1"/>
    </div>


    </div>
   </div>
  );
}

export default BrandList;
